import axios, { AxiosResponse } from "axios";

const appApi = axios.create();

appApi.interceptors.request.use((config) => {
  config.headers["x-correlation-id"] = crypto.randomUUID();
  return config;
});

export type { AxiosResponse };

export default appApi;
